import { Component, Input, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TransformKeyPipe } from '../../../../pipes/transform-key.pipe';
import { getValueByPath } from '../../../../utils/get-value-by-path';
import { TimezonePipe } from '../../../../pipes/timezone.pipe';
import { TimeZonePipeISFalse } from '../../../../constants/date-keys';


@Component({
  selector: 'app-create-view',
  standalone: true,
  templateUrl: './create-view.html',
  styleUrls: ['./create-view.scss'],
  imports: [CommonModule, TransformKeyPipe, TimezonePipe],
})
export class CreateView {
  @Input() logData: any;
  viewLogsData: any;

  // Stack of popups
  popupStack: Array<{ title: string; data: any }> = [];

  getValueByPath = getValueByPath;
  ngOnInit() {
    this.viewLogsData = this.logData;
    // console.log('CreateView initialized with logData:', this.logData);
  }

  constructor(private modalService: NgbModal) {
    // console.log('CreateView initialized with logData:', this.logData);
  }

  // Wrapper method for template to open popup
openPopupFromKey(title: unknown, data: any, template: TemplateRef<any>) {
  const safeTitle = String(title); // Convert unknown to string
  this.openPopup(safeTitle, data, template);
}
  // Push data to stack and open modal
  openPopup(title: string, data: any, content: TemplateRef<any>) {
    this.popupStack.push({ title, data });
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  // Remove topmost popup from stack when modal is closed
  closePopup() {
    this.popupStack.pop();
  }

  get popupTitle(): string {
    return this.popupStack.length
      ? this.popupStack[this.popupStack.length - 1].title
      : '';
  }

  get popupData(): any {
    return this.popupStack.length
      ? this.popupStack[this.popupStack.length - 1].data
      : null;
  }

  isObject(value: unknown): value is Record<string, any> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  isArray(value: unknown): value is any[] {
    return Array.isArray(value);
  }

  isCheckTimeZoneCheck(key: any): boolean {
    return TimeZonePipeISFalse.includes(key);
  }

  
asAny(value: unknown): any {
  return value as any;
}
  
}
